import React from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { Box, Paper, Typography } from '@mui/material';

const TextEditor2 = ({
  label = "Email Body",
  value,
  onChange,
  error,
  helperText,
  required = false
}) => {
  // Toolbar configuration
  const modules = {
    toolbar: [
      ['bold', 'italic', 'underline', 'strike'],
      [{ 'list': 'ordered'}, { 'list': 'bullet' }],
      [{ 'align': [] }],
      ['clean']
    ],
  };

  // Improved function to convert text to HTML while preserving structure
  const convertToHtml = (text) => {
    // If text is empty, return empty string
    if (!text) return '';

    // Split text into lines
    const lines = text.split('\n');
    
    // Group lines into paragraphs
    const paragraphs = [];
    let currentParagraph = [];

    lines.forEach(line => {
      // Trim the line
      const trimmedLine = line.trim();
      
      // If line is empty, it indicates a paragraph break
      if (trimmedLine === '') {
        // If we have a current paragraph, add it to paragraphs
        if (currentParagraph.length > 0) {
          paragraphs.push(currentParagraph);
          currentParagraph = [];
        }
      } else {
        // Add non-empty line to current paragraph
        currentParagraph.push(trimmedLine);
      }
    });

    // Add the last paragraph if it's not empty
    if (currentParagraph.length > 0) {
      paragraphs.push(currentParagraph);
    }

    // Convert paragraphs to HTML
    const htmlParagraphs = paragraphs.map(para => 
      `<p>${para.join('<br>')}</p>`
    ).join('');

    return htmlParagraphs;
  };

  // Updated function to remove HTML tags while preserving line breaks
  const removeHtmlTags = (html) => {
    // Create a temporary div to parse HTML
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = html;
   
    // Extract text content, preserving line breaks
    const text = tempDiv.innerText;
   
    return text;
  };

  const handleChange = (value) => {
    // When editing, convert to plain text
    const plainText = removeHtmlTags(value);
    onChange(plainText);
  };

  // Convert plain text to HTML when rendering
  const htmlValue = convertToHtml(value);

  return (
    <Box>
      {label && (
        <Typography
          variant="subtitle1"
          gutterBottom
          required={required}
          sx={{
            marginBottom: 1,
            ...(required && {
              '&:after': {
                content: '" *"',
                color: 'error.main'
              }
            })
          }}
        >
          {label}
        </Typography>
      )}
      <Paper
        elevation={3}
        sx={{
          border: error ? '1px solid red' : 'none',
          ...(error && { boxShadow: '0 0 0 1px red' })
        }}
      >
        <Box sx={{
          '.ql-toolbar': {
            borderTop: '1px solid #ccc',
            borderLeft: '1px solid #ccc',
            borderRight: '1px solid #ccc',
            borderRadius: '4px 4px 0 0',
            backgroundColor: '#f8f9fa'
          },
          '.ql-container': {
            height: '300px',
            border: `1px solid ${error ? 'red' : '#ccc'}`,
            borderRadius: '0 0 4px 4px'
          }
        }}>
          <ReactQuill
            value={htmlValue}
            onChange={handleChange}
            modules={modules}
            theme="snow"
          />
        </Box>
      </Paper>
      {error && helperText && (
        <Typography
          variant="caption"
          color="error"
          sx={{ marginLeft: 2, marginTop: 1 }}
        >
          {helperText}
        </Typography>
      )}
    </Box>
  );
};

export default TextEditor2;